<template>
  <div>
    <div class="emd-tabbar _bordered">
      <ul class="emd-tabbar__list">
        <li v-for="tab in tabs" :key="tab.slotName" class="emd-tabbar__item">
          <a
            v-if="tab.enabled"
            :class="handleChangeActive(tab)"
            @click="changeTab(tab)"
            :data-testid="`tab-${tab.slotName}`"
          >
            <span class="emd-text">{{ tab.label }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div data-testid="slot-content">
      <slot :name="currentTab.slotName" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'EmdTabs',

  props: {
    tabs: {
      type: Array,
      required: true
    },
    initialTab: String
  },

  data () {
    return {
      currentTab: {
        slotName: this.initialTab
      }
    }
  },

  created () {
    if (!this.initialTab) {
      this.currentTab.slotName = this.tabs[0].slotName
    }
  },

  methods: {
    handleChangeActive ({ slotName }) {
      return {
        _active: this.currentTab.slotName === slotName,
        'emd-tabbar__link': true
      }
    },
    changeTab (tab) {
      this.currentTab = tab
      this.$emit('changed', this.currentTab)
    }
  }
}
</script>
